import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../common/Button'
import RemoveDataConfirmationModal from '../../../common/RemoveDataConfirmationModal'
import { notificationActions } from '../../../../store/notifications'
import { removeRelatedCHUSAPatient } from '../../../../lib/fetchApi'
import { caseActions } from '../../../../store/case'

export default function RemoveRelatedpatient({id}) {
    const dispatch = useDispatch()
    const [removeLoading, setRemoveLoading] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const removePatientHandler = async () => {
        setShowConfirm(false)
        setRemoveLoading(true)

        let reqBody = {
            related_patients: [id]
        }
        
        let update = await removeRelatedCHUSAPatient(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))            
        } else {
            let dispatchBody = {
                folder: 'chusa_related_patients',
                itemId: id
            }
            dispatch(caseActions.removeFromArray(dispatchBody))
        }  

        setRemoveLoading(false)
    }

    return (
        <div style={{ position: 'relative' }}>
            <Button title='remove related patient' click={() => setShowConfirm(true)} btnStyle={'btn_remove_small'} isLoading={removeLoading}>
                <i className='ti ti-x'></i>
            </Button>
            {showConfirm && (
                <RemoveDataConfirmationModal
                    closeModal={() => setShowConfirm(false)}
                    removeData={removePatientHandler}
                    message={'Are you sure you want to remove this related patient?'}
                    position={'right'}
                />
            )}
        </div>
    )
}
